module.exports = __webpack_public_path__ + "b3e77787a4c80e9d07c5bc8f0d7eedbc.png";